import React from 'react';

type Props = {
  fillColor?: string;
}

const Bottoms = (props: Props): JSX.Element => (
  <svg id="Layer_1" data-name="Layer 1" data-testid="black-bottom-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9.25 19.46">
  <defs>
    <style>
      {`
       .cls-work-icon {
        fill: ${props?.fillColor || '#231f20'};
        stroke-width: 0px;
      }
      `}
    </style>
  </defs>
  <path className="cls-bottoms-icon" d="M4.57,1.81c-1.92,0-3.23-.22-3.25-.22-.11-.02-.2-.12-.2-.23V.23c0-.07.03-.13.08-.18.05-.04.12-.06.19-.06,3.34.48,6.35,0,6.38,0,.07,0,.14,0,.19.05.05.04.08.11.08.18v1.13c0,.12-.09.22-.2.23-1.19.16-2.31.22-3.28.22ZM1.6,1.16c.69.09,3.11.36,5.98,0v-.65c-.8.1-3.27.35-5.98,0v.65Z"/>
  <path className="cls-bottoms-icon" d="M9.02,19.46h-2.36c-.11,0-.21-.08-.23-.19l-1.84-10.52-1.9,10.52c-.02.11-.12.19-.23.19H.23c-.06,0-.12-.03-.17-.07-.04-.05-.07-.11-.07-.17L.42,4.51l.72-3.2c.03-.13.15-.21.28-.18.13.03.21.15.18.28l-.71,3.15-.4,14.42h1.78l2.1-11.63c.02-.11.12-.19.23-.19h0c.11,0,.21.08.23.19l2.03,11.63h1.92l-.55-14.54-.63-3.04c-.03-.13.06-.25.18-.28.13-.03.25.06.28.18l.64,3.08.57,14.82c0,.06-.02.13-.07.17-.04.05-.1.07-.17.07Z"/>
  <path className="cls-bottoms-icon" d="M4.63,7.64c-.13,0-.23-.11-.23-.23V.45c0-.13.11-.23.23-.23s.23.11.23.23v6.95c0,.13-.11.23-.23.23Z"/>
  <path className="cls-bottoms-icon" d="M5.86,5.44c-.13,0-.23-.11-.23-.23V1.78c0-.13.11-.23.23-.23s.23.11.23.23v3.42c0,.13-.11.23-.23.23Z"/>
  <path className="cls-bottoms-icon" d="M8.45,4.67c-.08,0-.17-.05-.21-.13l-1.54-2.97c-.06-.12-.01-.26.1-.32.11-.06.26-.02.32.1l1.54,2.97c.06.12.01.26-.1.32-.03.02-.07.03-.11.03Z"/>
  <path className="cls-bottoms-icon" d="M.75,4.9s-.07,0-.11-.03c-.11-.06-.16-.2-.1-.32l1.54-2.97c.06-.12.2-.16.32-.1.11.06.16.2.1.32l-1.54,2.97c-.04.08-.12.13-.21.13Z"/>
  <path className="cls-bottoms-icon" d="M6.5,3.99c-.13,0-.23-.11-.23-.23v-1.97c0-.13.11-.23.23-.23s.23.11.23.23v1.97c0,.13-.11.23-.23.23Z"/>
  <path className="cls-bottoms-icon" d="M3.47,5.23c-.13,0-.23-.11-.23-.23V1.58c0-.13.11-.23.23-.23s.23.11.23.23v3.42c0,.13-.11.23-.23.23Z"/>
  <path className="cls-bottoms-icon" d="M2.83,3.78c-.13,0-.23-.11-.23-.23v-1.97c0-.13.11-.23.23-.23s.23.11.23.23v1.97c0,.13-.11.23-.23.23Z"/>
</svg>
);

export default Bottoms;
